import { styled } from "@mui/material/styles";

const StyledForgotPassword = styled("div")`
  width: 100%;
  max-width: 500px;

  & > .forgot-password__btn {
    margin: 16px 0 24px;
  }
`;

const StyledForgotPasswordHeadings = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    max-width: 400px;
  }
`;

export { StyledForgotPassword, StyledForgotPasswordHeadings };
